import withRouter from "components/Common/withRouter";
import { ErrorMessage, useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { formatDistanceToNow } from "date-fns";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Select from "react-select";
//Import Breadcrumb
import ToastDialog from "components/Common/ToastDialog";
import { getDropDownList } from "../../http/fundLync/dropdown.helper";
//redux
import { dateFormatChange, uId, isPermission, decryptedValue, dateFormat } from "common/utility";
import API_SERVICES from "constants/app.constants";
import {
  addAuthorisedPerson,
  callAnchorList,
  editEntity,
  getAddress,
  getAuthorisedPersonEntityList,
  getAuthorisedPersonList,
  getCIUser,
  getCIUserRolewise,
  getEntity,
  getOneEntity,
  pushToTradeasyPayearly,
  checkEntityExistOrNot
} from "http/fundLync/entityAndAddress.helper";
import { callCheckUdyamNumber, callGetGSTINDetails, callGetPanDetails } from "http/gstin/gstin";
import moment from "moment/moment";
import { useAsyncDebounce } from "react-table";
import { callGetCINDetails } from "../../http/cin/cin";
import { formatDateString, formatDateString1 } from "./borrowingProfile";
import EntityAddress from "./entityAddress";
import UsersTable from "./user";
import CommonDialog from "components/Common/CommonDialog";
import { callFinancialCINSubmit, callGetProbeCreditRatings } from "http/fundLync/entityDocuments.helper";
import BankDetails from "./bankDetails";
import { getUser } from "http/fundLync/user.helper";
import axios from "axios";
import PointOfContact from "./pointOfContact";
import { addCounterpartyPoc, deleteAnchorPoc, getAnchorPoc, getPrimaryPoc } from "http/fundLync/poc.helper";
import CreditRatings from "./creditRating";
import { callGetCIUser } from "http/fundLync/dealFinancier";
import InsuranceDetails from "./insuranceDetails";
import AnchorContact from "./anchorContact";

const UpdateEntity = (props) => {
  document.title = "Entity Details | FundLync";

  const currentDate = new Date().toISOString().split("T")[0];
  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const entityDetails = decryptedValue(localStorage.getItem("user"));
  const entityId = atob(encodedId);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [isGSTINSerching, setGSTINSerching] = useState(false);
  const [isPanSerching, setPANSerching] = useState(false);
  const [isCINSerching, setCINSerching] = useState(false);
  const [gstinInfo, setGstinInfo] = useState();
  const [entity, setEntity] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isNonFinSelected, setNonFinSelected] = useState(false);
  const [isMSMESelected, setMSMESelected] = useState(false);
  const [isFinSelected, setFinSelected] = useState(false);
  const [isConstitution, setConstitution] = useState(false);
  const [nonFinTypeList, setNonFinType] = useState([]);
  const [entityTypeList, setEntityType] = useState([]);
  const [msmeTypeList, setMsmeType] = useState([]);
  const [finTypeList, setFinTypeList] = useState([]);
  const [regionList, setReigonList] = useState([]);
  const [isEditEntityPermission, setEditEntityPermission] = useState(false);
  const [ratingList, setRatingList] = useState([]);
  const [anchorList, setAnchorList] = useState([]);
  const [isCounterparty, setIsCounterparty] = useState(false);
  const [initialAnchors, setInitialAnchors] = useState([]);
  const [selectedMulti, setSelectedMulti] = useState([]);
  const [msmeDropDown, setMsmeDropDown] = useState([]);
  const [msmeNmsme, setMsmeNType] = useState('');
  const [managerList, setManagerList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [description,setDescription]=useState('');
  const [loader, setLoader] = useState(false);
  const [pocList, setPocList] = useState([]);
  const [isReadMore, setIsReadMore] = useState(false);
  const [isReadMoreDes, setIsReadMoreDes] = useState(false);
  const [anchorPocList, setAnchorPocList] = useState([]);
  const [anchorContactIds, setAnchorContactIds] = useState({});
  const [isInsuranceAccordionOpen, setIsInsuranceAccordionOpen] = useState(false);
  const [isCreditAccordionOpen, setIsCreditAccordionOpen] = useState(false);
  const [isAddressAccordionOpen, setIsAddressAccordionOpen] = useState(false);
  const [isPocAccordionOpen, setIsPocAccordionOpen] = useState(false);
  const [isUserAccordionOpen, setIsUserAccordionOpen] = useState(false);
  const [isAnchorAccordionOpen, setIsAnchorAccordionOpen] = useState(false);
  const onGSTINChange = useAsyncDebounce((value) => {
    if (!validation.errors.gstnIn) findGSTINDetails(value);
  }, 400);

  const onPanChange = useAsyncDebounce((value) => {
    if (!validation.errors.pan) findPanDetails(value);
  }, 400);
  const checkPermissions = async () => {
    const editEntitypermission = await isPermission(
      "entity_detail",
      "edit_permission"
    );
    
    setEditEntityPermission(editEntitypermission);
  };
  const handleAccordionToggle = (isOpen) => {
    setIsInsuranceAccordionOpen(isOpen);
  };

  const handleCreditAccordionToggle = (isOpen) => {
    setIsCreditAccordionOpen(isOpen);
  };
  const handleAddressAccordionToggle = (isOpen) => {
    setIsAddressAccordionOpen(isOpen);
  };
  const handlePocAccordionToggle = (isOpen) => {
    setIsPocAccordionOpen(isOpen);
  };
  const handleUserToggle = (isOpen) => {
    setIsUserAccordionOpen(isOpen);
  };
  const handleAnchorToggle = (isOpen) => {
    setIsAnchorAccordionOpen(isOpen);
  };
  useEffect(() => {
    const loadData = async () => {
      try {
        // Fetch the entity details
        const entityResponse = await getOneEntity({ entityId });
        let entityData = entityResponse.data;
        const formattedDate = formatDateString1(entityData[0].dateOfIncorporation);
        if (entityData[0].anchors) {
          const initialAnchors1 = entityData[0].anchors.map(anchor => ({
            label: anchor.anchorName,
            value: anchor.anchorId
          }));
          setInitialAnchors(initialAnchors1);
          setSelectedMulti(initialAnchors1);
          validation.setFieldValue('anchors', initialAnchors1)
        }
        entityData[0].dateOfIncorporation = formattedDate;
        setMsmeNType(entityData[0].msmeNoNmsme),
        setEntity(entityData)
        
        if (entityData[0].entityType === "Customer") {
          const nonFinancierResponse = await getDropDownList({ dropdownName: "Non-Financier Type" });
          const nonFinDropdownValues = nonFinancierResponse.data?.rows?.find(
            (dv) => dv.dropdownName === "Non-Financier Type"
          )?.dropdownValues || [];

          setNonFinSelected(true);
          setNonFinType(nonFinDropdownValues);

          if (entityData[0].nonFinancierType === "Counterparty") {
            setIsCounterparty(true);
          }
          if (entityData[0].msmeNoNmsme === "MSME") {
            const msmeResponse = await getDropDownList({ dropdownName: "MSME Type" });
            const msmeDropdownValues = msmeResponse.data?.rows?.find(
              (dv) => dv.dropdownName === "MSME Type"
            )?.dropdownValues || [];

            setMSMESelected(true);
            setMsmeType(msmeDropdownValues);
          } else {
            setMSMESelected(false);
          }
        } else {
          setNonFinSelected(false);
        }

        if (entityData[0].entityType === "Financier") {
          const financierResponse = await getDropDownList({ dropdownName: "financier_type" });
          const financierDropdownValues = financierResponse.data?.rows?.find(
            (dv) => dv.dropdownName === "financier_type"
          )?.dropdownValues || [];
          setFinSelected(true);
          setIsCounterparty(false);
          setFinTypeList(financierDropdownValues);
        }

        const [entityTypeResponse, ratingsResponse, regionResponse] = await Promise.all([
          getDropDownList({ dropdownName: "Entity Type" }),
          getDropDownList({ dropdownName: "Ratings" }),
          getDropDownList({ dropdownName: "region" })
        ]);

        const entityTypeValues = entityTypeResponse.data?.rows?.find(
          (dv) => dv.dropdownName === "Entity Type"
        )?.dropdownValues || [];

        const ratingValues = ratingsResponse.data?.rows?.find(
          (dv) => dv.dropdownName === "Ratings"
        )?.dropdownValues || [];

        const regionValues = regionResponse.data?.rows?.find(
          (dv) => dv.dropdownName === "region"
        )?.dropdownValues || [];

        setEntityType(entityTypeValues);
        setRatingList(ratingValues);
        setReigonList(regionValues)
        checkPermissions();
      } catch (error) {
      }
    };
    getPrimaryPoc({ entityId })
      .then((response) => {
        if (response.status) {
            setPocList(response?.data);
        }
        else{
            setPocList([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
    loadData();
  }, []);

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };
  const findGSTINDetails = (gstin) => {
    setGSTINSerching(true);
    callGetGSTINDetails({ gstnIn: gstin })
      .then((result) => {
        if (result.code == 200 && result.status) {
          const { data: gstinDetails } = result;
          const { ctb, rgdt } = gstinDetails;
          setGstinInfo(gstinDetails);

          validation.setFieldValue("entityConstitution", ctb);
          if (
            ctb == "Private Limited Company" ||
            ctb == "Public Limited Company"
          ) {
            setConstitution(true);
          } else {
            setConstitution(false);
          }
          validation.setFieldValue(
            "dateOfIncorporation",
            dateFormatChange(rgdt, "DD/MM/YYYY", "YYYY-MM-DD")
          );
          validation.setFieldValue("pan", gstin.substring(2, 12));
        } else {
          setToastInfo({
            message: "Incorrect GSTIN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("gstnIn", "");
          validation.setFieldValue("entityConstitution", "");
          validation.setFieldValue("dateOfIncorporation", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "GSTIN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("entityConstitution", "");
        validation.setFieldValue("dateOfIncorporation", "");
      })
      .finally((f) => {
        setGSTINSerching(false);
      });
  };
  const onCINChange = useAsyncDebounce((value) => {
    if (!validation.errors.cin) findCINDetails(value);
  }, 400);

  const checkIfalreadyExist = async (value) => {
    let status = await checkEntityExistOrNot(value)
    return status.status
  }
  const findPanDetails = (pan) => {
    setPANSerching(true);
    callGetPanDetails({ pan: pan })
      .then(async(result) => {
        if (result.code == 200 && result.data.status !== "INVALID" && await checkIfalreadyExist({ pan: pan })) {
          setToastInfo({
            message: "PAN already registered",
            showToast: true,
            role: "error",
          });
        } else if (result.code == 200 && result.data.status !== "INVALID") {
          const { data: panDetails } = result;
          validation.setFieldValue("pan", pan);
          const { full_name, category } = panDetails;
          validation.setFieldValue("entityName", full_name);
          if (category == "Company") {
            validation.setFieldValue("entityConstitution", "Private Limited Company");
          } else if (category == "Firm") {
            validation.setFieldValue("entityConstitution", "Partnership");
          } else if (category == "Individual") {
            validation.setFieldValue("entityConstitution", "Proprietorship");
          }
        } else {
          setToastInfo({
            message: "Incorrect PAN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("entityName", "");
          validation.setFieldValue("entityConstitution", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "PAN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("entityName", "");
        validation.setFieldValue("entityConstitution", "");
      })
      .finally((f) => {
        setPANSerching(false);
      });
  };
  const findCINDetails = (cin) => {
    setCINSerching(true);
    callGetCINDetails({ cin: cin })
      .then(async (result) => {
        if (result.code == 200 && result.status) {
          if (await checkIfalreadyExist({cin})) {
            setToastInfo({
              message: "CIN already registered",
              showToast: true,
              role: "error",
            });
            validation.setFieldValue("cin", "");
          } else {
            const { data: cinDetails } = result;
            const CIN = cinDetails["CIN "]; 
            validation.setFieldValue("cin", CIN);

            if (CIN.includes("PTC")) {
              validation.setFieldValue("entityConstitution" , "Private Limited Company");
            } else if (CIN.includes("PLC")) {
              validation.setFieldValue("entityConstitution" , "Public Limited Company");
            } else if (CIN.includes("STP")) {
              validation.setFieldValue("entityConstitution", "Proprietorship");
            } else {
              validation.setFieldValue("entityConstitution", "");
            }

            
          }
        } else {
          setToastInfo({
            message: result?.message || "Incorrect CIN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("cin", "");
          validation.setFieldValue("entityConstitution", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "CIN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("cin", "");
        validation.setFieldValue("constitution", "");
      })
      .finally((f) => {
        setCINSerching(false);
      });
  };
  const callAfterSave = () => {
    getOneEntity({ entityId })
      .then((response) => {
        if (response.status) {
          setEntity(response?.data);
      }
      else{
          setPocList([]);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
      }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      entityName: entity[0]?.entityName || "",
      gstnIn: entity[0]?.gstnIn || "",
      cin: entity[0]?.cin || "",
      pan: entity[0]?.pan || "",
      entityConstitution: entity[0]?.entityConstitution || "",
      region: entity[0]?.region || "",
      natureOfBusiness: entity[0]?.natureOfBusiness || "",
      entityType: entity[0]?.entityType || "",
      dateOfIncorporation: entity[0]?.dateOfIncorporation || "",
      companyDescription: entity[0]?.companyDescription || "",
      nonFinancierType: entity[0]?.nonFinancierType || "",
      anchors: initialAnchors || [],
      msmeNoNmsme: entity[0]?.msmeNoNmsme || "",
      udyamNumber: entity[0]?.udyamNumber || "",
      msmeType: entity[0]?.msmeType || "",
      financierType: entity[0]?.financierType || "",
      creditRating: entity[0]?.creditRating || "",
      // businessType: entity[0]?.businessType || "",
      programManager: entity[0]?.programManager || "",
      anchorPoc: entity[0]?.anchorPoc || "",
      anchorContactNo :entity[0]?.anchorContactNo || "",
      anchorEmail: entity[0]?.anchorEmail || "",
      designationValue: entity[0]?.designationValue || "",
      programOwner: entity[0]?.programOwner || "",
      fiPartnershipManager: entity[0]?.fiPartnershipManager || "",
      RM: `${entity[0]?.programOwnerUser?.first_name} ${entity[0]?.programOwnerUser?.last_name}` || "",
      FIRM: `${entity[0]?.fiPartnershipManagerUser?.first_name} ${entity[0]?.fiPartnershipManagerUser?.last_name}` || "",
      programManageruser: `${entity[0]?.programManagerUser?.first_name} ${entity[0]?.programManagerUser?.last_name}` || "",
      turnOver: entity[0]?.turnOver || "",
      totalPurchase: entity[0]?.totalPurchase||"",
    },
    validationSchema: Yup.object({
      entityName: Yup.string().required("Please Enter Entity Name"),
      gstnIn: Yup.string()
        .test("gstnCheck", "Enter correct GSTIN!", (value) => {
          if (value && value.length > 0) {
            const isGstinValid = Yup.string()
              .matches(API_SERVICES.GSTN_PATTERN, "Enter correct GSTIN!")
              .isValidSync(value);

            return isGstinValid;
          }

          return true;
        })
        .test("panCheck", "GSTIN & PAN mismatch", (value, { parent }) => {
          if (value?.length > 0) {
            const pan = value.substring(2, 12);
            return pan === parent.pan || !parent.pan;
          }

          return true;
        }),
      cin: isConstitution
        ? Yup.string()
          .matches(API_SERVICES.CIN_PATTERN, "Enter a valid CIN number")
        : Yup.string().matches(
          API_SERVICES.CIN_PATTERN,
          "Enter a valid CIN number"
        ),
      pan: Yup.string()
        .matches(API_SERVICES.PAN_PATTERN, "Enter a valid PAN number"),
        // .required("PAN is required"),
      entityConstitution: Yup.string().required(
        "Please Enter Entity Constitution"
      ),
      natureOfBusiness: isNonFinSelected
        ? Yup.string()
        : Yup.string(),
      entityType:
        entityDetails.entityType == "Owner"
          ? Yup.string()
          : Yup.string(),
      nonFinancierType: isNonFinSelected
        ? Yup.string()
        : Yup.string(),
        msmeType: Yup.string()
        .when(['isNonFinSelected', 'isMSMESelected'], {
          is: (isNonFinSelected, isMSMESelected) => isNonFinSelected && isMSMESelected,
          then: Yup.string(),
          otherwise: Yup.string(),
        }),
      msmeNoNmsme: isNonFinSelected
        ? Yup.string()
        : Yup.string(),
      udyamNumber: Yup.string()
      .matches(
        /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/,
        "Udyam number must be in the format UDYAM-XX-00-0000000"
      ),
      financierType: isFinSelected
        ? Yup.string()
        : Yup.string(),
      dateOfIncorporation: Yup.string(),
      programManager: Yup.string(),
      anchorContactNo: isNonFinSelected
        ? Yup.string()
            .matches(/^[1-9][0-9]*$/, "Mobile number must not start with zero and should contain only digits")
            .min(10, "Mobile number must be at least 10 digits")
            .max(10, "Mobile number must be at most 10 digits")
        : Yup.string()
            .matches(/^[1-9][0-9]*$/, "Mobile number must not start with zero and should contain only digits")
            .min(10, "Mobile number must be at least 10 digits")
            .max(10, "Mobile number must be at most 10 digits"),
      anchorEmail: Yup.string().email("Invalid email address"),
           region: Yup.string().required("Please select a Region"),
      anchorPoc: !isFinSelected
        ? Yup.string()
        :Yup.string(),
      designationValue:Yup.string(),
      programOwner: isNonFinSelected
        ? Yup.string().required("Please select a Relationship Manager")
        : Yup.string(),
      fiPartnershipManager: Yup.string(),
      creditRating: !isFinSelected
        ? Yup.string()
        : Yup.string(),
      anchors: isCounterparty
        ? Yup.array().min(1, "Please select at least one anchor")
        : Yup.array(),
      turnOver: Yup.number()
        .typeError("Turnover Amount must be a number")
        .min(0, "Turnover cannot be negative")
        .max(99999999999999, "Turnover cannot more than 14 digits"),
        totalPurchase: Yup.number()
        .typeError("Turnover Amount must be a number")
        .min(0, "Turnover cannot be negative")
        .max(99999999999999, "Turnover cannot more than 14 digits"),
    }),
    onSubmit: (values) => {
      const entityObj = {
        entityName: values.entityName,
        entityType: values.entityType,
        gstnIn: values.gstnIn,
        cin: values.cin,
        pan: values.pan,
        entityConstitution: values.entityConstitution,
        region: values.region,
        dateOfIncorporation: values.dateOfIncorporation,
        companyDescription: values.companyDescription,
        financierType: values.financierType ,
        // id: +entityId,
          msmeNoNmsme: values.msmeNoNmsme ,
          udyamNumber: values.udyamNumber,
          programOwner: values.programOwner,
        ...(isNonFinSelected && {
          msmeType: values.msmeType ,
          nonFinancierType: values.nonFinancierType,
          natureOfBusiness: values.natureOfBusiness,
          // businessType: values.businessType,
          programManager: values.programManager,
          anchorPoc: values.anchorPoc,
          anchorContactNo: values.anchorContactNo || "",
          anchorEmail: values.anchorEmail || "",
          designationValue: values.designationValue,
          
          turnOver: values?.turnOver || '',
          totalPurchase: values?.totalPurchase || '',
        }),
        fiPartnershipManager: values.fiPartnershipManager,
      };
      if (selectedMulti?.length > 0 || values.anchors?.length > 0) {
        entityObj.anchors = selectedMulti?.map(anchor => anchor.value)
      }
      if (values.creditRating) {
        entityObj.creditRating = values.creditRating
      }
      if(entityDetails.entityType === "Partner" || entityDetails.entityType === "Owner"){
        entityObj.id= +entityId
      }else{
        entityObj.id= entityDetails.entityId
      }
      if (gstinInfo) {
        const { adadr, pradr } = gstinInfo;
        if(adadr && pradr){
          const isAddressExists =
          pradr.hasOwnProperty("addr") || adadr.length > 0;

        if (isAddressExists) {
          const { addr: address } = pradr.hasOwnProperty("addr")
            ? pradr
            : adadr[0];
          const addressStr = [address.bno, address.st, address.loc].join(",");

          if (address) {
            entityObj["address"] = {
              address1: addressStr,
              city: address.dst,
              state: address.stcd,
              pincode: address.pncd,
              entityId: +entityId,
              addressType: "gstn",
            };
          }
        }
        
        }
      }
      
      editEntity(entityObj)
        .then((response) => {
          if (response.code == 201 && response.status) {
            setEditMode(false)
            if (
              (entityObj.entityConstitution == "Private Limited Company" ||
                entityObj.entityConstitution == "Public Limited Company") &&
              entityObj.cin &&
              entity[0].status == 3
            ) {
              callAddDirectorFromCIN(entityObj.cin);
              callAddShareholdingFromCIN(entityObj.cin);
            }
            setToastInfo({
              message: "Entity Details Saved",
              showToast: true,
              role: "success",
            });
            if (!entity[0].pan && validation.values.pan) {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              callAfterSave();
            }
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
          getOneEntity({ entityId })
            .then((response) => {
              
              let entityData = response.data;
              const formatedDate = formatDateString1(
                entityData[0].dateOfIncorporation
              );

              entityData[0].dateOfIncorporation = formatedDate;
              if (entityData[0].entityType == "Customer") {
                getDropDownList({ dropdownName: "Non-Financier Type" })
                  .then((response) => {
                    const dropdownValues =
                      response.data?.rows?.find(
                        (dv) => dv.dropdownName == "Non-Financier Type"
                      )?.dropdownValues || [];
                    setNonFinSelected(true);
                    setNonFinType(dropdownValues);
                  })
                  .catch((error) => { });
                // if (entityData[0].nonFinancierType == "Counterparty") {
                //   setMSMESelected(true);
                // } else {
                //   setMSMESelected(false);
                // }
              }
              else {
                setNonFinSelected(false);
              }
              setEntity(entityData);
            })
            .catch((error) => {});
        })
        .catch((error) => { });
      validation.resetForm();
    },
  });

  const callAddDirectorFromCIN = (cin) => {
    callGetCINDetails({ cin: cin })
      .then((response) => {
        if (response.code == 200) {
          const allDirectors = response?.data.directors;
          const directorArr = allDirectors.map((elem) => {
            const fullName = elem.Name;
            const nameParts = fullName.split(" ");

            let firstName = nameParts[0];
            let lastName = nameParts[nameParts.length - 1];

            return {
              firstName: firstName,
              lastName: lastName,
              din: elem["DIN/PAN"],
              designation: elem.Designation,
              dateOfAppointment: moment(
                elem["Begin date"],
                "DD/MM/YYYY"
              ).format("YYYY-MM-DD"),
              entityId: +entityId,
              status: 3,
              type: "director",
            };
          });


          addAuthorisedPerson({ authorisedPerson: directorArr })
            .then((response) => {
              if (response.code == 201 && response.status) {
                getAuthorisedPersonList({ entityId, type: "director" });
              }
            })
            .catch((error) => { });
        }
      })
      .catch((error) => { });
  };

  const callAddShareholdingFromCIN = (cin) => {
    const postParams = {
      entity_id: +entityId,
      cin_llpin: cin,
    };
    callFinancialCINSubmit(postParams);
  };

  const dialogAction = (action, data) => {
    setShowCommonDialog({ isShow: false });
  };
  useEffect(() => {
    loadAnchorList()
    if (isNonFinSelected) {
      getDropDownList({ dropdownName: "msme_nonMsme" })
        .then((response) => {
          const values =
            response.data?.rows?.find((dv) => dv.dropdownName === "msme_nonMsme")
              ?.dropdownValues || [];
          setMsmeDropDown(values);
        })
        .catch((error) => { });
    }
    //Getting Program manager
    getCIUserRolewise({role:"Program Manager"})
    .then((response) => {
      if (response.status) {
        setManagerList(response.data.rows)
      }
    })
    .catch((error) => {
       console.log(error);
    });

    //Getting RM
    callGetCIUser()
      .then((res) => {
        setOwnerList(res.data.rows)
      })

    //Getting FI Manager
    getCIUserRolewise({role:"FI RM"})
    .then((response) => {
      if (response.status) {
        setPartnerList(response.data.rows)
      }
    })
    .catch((error) => {
       console.log(error);
    });

  }, [isNonFinSelected]);


  const anchorValues = useAsyncDebounce((value) => {
    loadAnchorList(value);
  }, 500);


  const loadAnchorList = (search) => {
    callAnchorList({ page: 1, limit: 500, searchKey: search })
      .then((response) => {
        const formattedOptions = response?.data.data.map((option) => ({
          label: option.entityName,
          value: option.id,
        }));
        setAnchorList(formattedOptions);
        return formattedOptions;
      })
      .catch((error) => { });
  };

  const getAnchorContactsList = (anchorId) => {
    getAnchorPoc({ entityId: anchorId })
      .then((response) => {
        if (response.status && response?.data?.length > 0) {
          setAnchorPocList(response?.data);
          const contactIds = response.data.map((item) => ({
            contactId: item.contactId,
            counterpartyId: item.counterpartyId,
            anchorId: item.anchorId,
          }));
          setAnchorPocList(response?.data);
          setAnchorContactIds((prev) => ({
            ...prev,
            [anchorId]: contactIds,
          }));
        } else {
          setAnchorPocList([]);
          setAnchorContactIds((prev) => ({
            ...prev,
            [anchorId]: [],
          }));
        }
      })
      .catch((error) => {
        console.error(`Error fetching contacts for anchor ${anchorId}:`, error);
      });
  };
  
  useEffect(() => {
    if (entityId) {
      getAnchorContactsList(entityId);
    }
  }, [entityId]);

  const fetchAnchorContacts = () => {
    getAnchorContactsList(entityId);
  };

  const handleMulti = async (selectedOptions) => {
    const previousAnchors = selectedMulti.map(anchor => anchor.value);
    const newAnchors = selectedOptions.map(anchor => anchor.value);
    const anchorsToRemove = previousAnchors.filter(anchor => !newAnchors.includes(anchor));
    setSelectedMulti(selectedOptions);
    validation.setFieldValue('anchors', selectedOptions);
    try {
      const anchorsToRemoveData = anchorsToRemove.map((anchorId) => {
        const anchorData = anchorPocList.find(item => item.anchorId === anchorId);
        if (anchorData) {
          return {
            anchorId: Number(anchorId),
            counterpartyId: [Number(entityId)],
            contactId: Number(anchorData.contactId),
            status: 0,
          };
        }

        return null;
      }).filter(Boolean);
      if (anchorsToRemoveData.length > 0) {
        await Promise.all(
          anchorsToRemoveData.map(async (requestData) => {

            try {
              await addCounterpartyPoc(requestData);
              const deleteResponse = await deleteAnchorPoc({ id: requestData.anchorId });
              if (deleteResponse.code === 201 && deleteResponse.status) {
                getAnchorContactsList(entityId);
              }
            } catch (error) {
              console.error(`Error processing removal for anchor ${requestData.anchorId}:`, error);
            }
          })
        );
      }
    } catch (error) {
      console.error('Error processing anchor selections:', error);
    }
  };
  

  const handleChangeradio = (e, option) => {
    setMsmeNType(option.displayName);
    validation.setFieldValue("msmeNoNmsme", option.displayName);
    if (option.displayName === "MSME") {
      getDropDownList({ dropdownName: "MSME Type" })
        .then((response) => {
          const dropdownValues =
            response.data?.rows?.find((dv) => dv.dropdownName === "MSME Type")
              ?.dropdownValues || [];
          setMSMESelected(true);
          setMsmeType(dropdownValues);
        })
        .catch((error) => { });
    } else {
      setMSMESelected(false);
    }

    validation.handleChange(e);
  };

  const formatFinancierName = (type) => {
    if (!type) return '-';
    if(type == 'NBFC') return type
    return type
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' ');
  };

  const getDisplayNamePOC = (user) => {
    const firstName = user?.firstname ? toSentenceCase(user.firstname) : '';
    const lastName = user?.lastname ? toSentenceCase(user.lastname) : '';
    if (firstName || lastName) {
      return `${firstName || ''} ${lastName || ''}`.trim();
    } else {
      return '';
    }
  };

  const toSentenceCase = (str) => {
    if (!str || str === undefined ) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const formatUdyamNumber = (value) => {
    value = value.replace(/[^a-zA-Z0-9]/g, '');
    value = value.toUpperCase();
    if (value.length > 5) value = `${value.slice(0, 5)}-${value.slice(5)}`;
    if (value.length > 8) value = `${value.slice(0, 8)}-${value.slice(8)}`;
    if (value.length > 11) value = `${value.slice(0, 11)}-${value.slice(11)}`;
    return value;
  };
  
  const handleUdyamNumberChange = (e) => {
    const value = e.target.value;
    findudyamnumber(value, entityId);
};
  
const findudyamnumber = (udyamNumber, entityId) => {
    setLoader(true);
    callCheckUdyamNumber({ udyamNumber, entityId })
        .then(async (result) => {
            if (result.code === 200 && result.status) {
                // setIsAlready(true);
                setToastInfo({
                    message: "Udyam number already registered",
                    showToast: true,
                    role: "error",
                });
                validation.setFieldValue('udyamNumber', "");
            } else {
                const formattedValue = formatUdyamNumber(udyamNumber);
                validation.setFieldValue('udyamNumber', formattedValue);
            }
        })
        .catch((e) => {
            setToastInfo({
                message: "Error checking Udyam number",
                showToast: true,
                role: "error",
            });
            validation.setFieldValue("udyamNumber", "");
        })
        .finally(() => {
            setLoader(false);
        });
};
const formatDateTime = (dateTimeString) => {
  const dateTime = new Date(dateTimeString);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  return dateTime.toLocaleString("en-US", options);
};
const callTogetDiscription = async () => {
  await callGetProbeCreditRatings({ entityId })
    .then((response) => {
      if (response.status && response?.data?.description?.length > 0) {
        setDescription(response.data.description)
      }
      else {
       setDescription('');
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

useEffect(() => {
  callTogetDiscription();
}, []);

const toggleReadMore = () => {
  setIsReadMore(!isReadMore);
};
const truncatedDescription = description
? description.slice(0, 290)
: "";

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <Card>
            <CardBody>
            <div >
              <div style={{cursor: "pointer"}}>
                {editMode ? 
                <div className="text-sm-end">
                    <Button
                      type="button"
                      color="outline-success"
                      className="btn-rounded mb-2 me-2"
                      onClick={toggleEditMode}
                    >
                      close
                    </Button>
                </div> : 
                <div className="d-flex justify-content-between align-items-center mb-3">
                  
                
                <div className="ms-auto">
                  {/* <i className="mdi mdi-pencil font-size-16 text-success me-1" onClick={toggleEditMode}>
                    <span className="font-size-12">Edit</span>
                  </i> */}
                  <Button
                      type="button"
                      color="success"
                      className="btn-rounded mb-2 me-2"
                      onClick={toggleEditMode}
                    >
                      Edit
                    </Button>
                </div>
              </div>
              }
              </div>
            </div>
                  
            
              {isEditEntityPermission && editMode ? (
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  
                  <Row>
                    <Col sm="12" md="6">
                      <Label className="required-sign form-label mt-4">GSTIN</Label>
                      <div className="gstin-progress">
                        <Input
                          name="gstnIn"
                          type="text"
                          placeholder="Enter GSTIN"
                          onChange={(e) => {
                            validation.handleChange(e);
                            onGSTINChange(e.target.value);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.gstnIn || ""}
                          invalid={
                            validation.touched.gstnIn &&
                            validation.errors.gstnIn
                          }
                          disabled={entity[0]?.gstnIn || isGSTINSerching}
                        />
                        {isGSTINSerching && (
                          <div
                            className="spinner-border progress-load"
                            role="status"
                            style={{
                              top: "10px",
                              width: "1rem",
                              height: "1rem",
                              "border-width": "0.2em",
                            }}
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}

                        {validation.touched.gstnIn &&
                          validation.errors.gstnIn ? (
                          <FormFeedback type="invalid">
                            {validation.errors.gstnIn}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="required-sign form-label mt-4">PAN </Label>
                      <Input
                        name="pan"
                        type="text"
                        placeholder="Enter entity Pan"
                        onChange={(e) => {
                          validation.handleChange(e);
                          onPanChange(e.target.value);
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.pan || ""}
                        invalid={
                          validation.touched.pan && validation.errors.pan
                        }
                        disabled={entity[0]?.pan || isPanSerching}
                      />
                      {isPanSerching && (
                          <div
                            className="spinner-border progress-load"
                            role="status"
                            style={{
                              top: "10px",
                              width: "1rem",
                              height: "1rem",
                              "border-width": "0.2em",
                            }}
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}
                      {validation.touched.pan && validation.errors.pan ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pan}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="form-label mt-4">
                        CIN
                      </Label>
                      <Input
                        name="cin"
                        type="text"
                        placeholder="Enter CIN"
                        onChange={(e) => {
                          validation.handleChange(e);
                          onCINChange(e.target.value);
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.cin || ""}
                        invalid={
                          validation.touched.cin && validation.errors.cin
                        }
                        disabled={entity[0]?.cin || isCINSerching}
                      />
                      {isCINSerching && (
                          <div
                            className="spinner-border progress-load"
                            role="status"
                            style={{
                              top: "10px",
                              width: "1rem",
                              height: "1rem",
                              "border-width": "0.2em",
                            }}
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}
                      {validation.touched.cin && validation.errors.cin ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cin}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="required-sign form-label mt-4">Entity Name <i className="mdi mdi-asterisk"></i></Label>
                      <Input
                        name="entityName"
                        type="text"
                        placeholder="Enter entity Name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.entityName || ""}
                        invalid={
                          validation.touched.entityName &&
                          validation.errors.entityName
                        }
                        disabled
                      />
                      {validation.touched.entityName &&
                        validation.errors.entityName ? (
                        <FormFeedback type="invalid">
                          {validation.errors.entityName}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="form-label mt-4">
                        Date of Incorporation
                      </Label>
                      <Input
                        name="dateOfIncorporation"
                        type="date"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.dateOfIncorporation || ""}
                        invalid={
                          validation.touched.dateOfIncorporation &&
                          validation.errors.dateOfIncorporation
                        }
                        max={currentDate}
                      />
                      {validation.touched.dateOfIncorporation &&
                        validation.errors.dateOfIncorporation ? (
                        <FormFeedback type="invalid">
                          {validation.errors.dateOfIncorporation}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="required-sign form-label mt-4">
                        Entity Constitution <i className="mdi mdi-asterisk"></i>
                      </Label>
                      <Input
                        name="entityConstitution"
                        type="select"
                        placeholder="Enter entity Description"
                        onChange={(e) => {
                          validation.handleChange(e);
                          if (
                            e.target.value == "Private Limited Company" ||
                            e.target.value == "Public Limited Company"
                          ) {
                            setConstitution(true);
                          } else {
                            setConstitution(false);
                          }
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.entityConstitution || ""}
                        invalid={
                          validation.touched.entityConstitution &&
                          validation.errors.entityConstitution
                        }
                      >
                        <option value="" disabled>
                          Select Entity Constitution
                        </option>
                        <option value="Private Limited Company">
                          Private Limited Company
                        </option>
                        <option value="Limited Liability Partnership">
                          Limited Liability Partnership
                        </option>
                        <option value="Proprietorship">Proprietorship</option>
                        <option value="Partnership">Partnership</option>
                        <option value="Public Limited Company">
                          Public Limited Company
                        </option>
                      </Input>
                      {validation.touched.entityConstitution &&
                        validation.errors.entityConstitution ? (
                        <FormFeedback type="invalid">
                          {validation.errors.entityConstitution}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    {entityDetails.entityType == "Owner" && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Select Entity type 
                        </Label>
                        <Input
                          name="entityType"
                          type="select"
                          onChange={(e) => {
                            if (e.target.value == "Customer") {
                              getDropDownList({
                                dropdownName: "Non-Financier Type",
                              })
                                .then((response) => {
                                  const dropdownValues =
                                    response.data?.rows?.find(
                                      (dv) =>
                                        dv.dropdownName == "Non-Financier Type"
                                    )?.dropdownValues || [];
                                  setNonFinSelected(true);
                                  setNonFinType(dropdownValues);
                                  setFinSelected(false);
                                })
                                .catch((error) => { });
                            } else {
                              setNonFinSelected(false);
                              setMSMESelected(false);
                              setIsCounterparty(false)
                              setMsmeNType('')
                              setFinSelected(true);
                              getDropDownList({
                                dropdownName: "financier_type",
                              })
                                .then((response) => {
                                  const dropdownValues =
                                    response.data?.rows?.find(
                                      (dv) =>
                                        dv.dropdownName == "financier_type"
                                    )?.dropdownValues || [];
                                  setNonFinSelected(false);
                                  setFinTypeList(dropdownValues);
                                  setFinSelected(true);
                                })
                                .catch((error) => { });
                            }
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.entityType || ""}
                          invalid={
                            validation.touched.entityType &&
                            validation.errors.entityType
                          }
                        >
                          <option value="" disabled>
                            Select Entity Type
                          </option>
                          {entityTypeList.map((option) => (
                            <option key={uId()} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.entityType &&
                          validation.errors.entityType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.entityType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}

                    {isNonFinSelected && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Non financier (Entity)Type 
                        </Label>
                        <Input
                          name="nonFinancierType"
                          type="select"
                          onChange={(e) => {
                            if (e.target.value == "Counterparty") {
                              setIsCounterparty(true);
                            } else {
                              setIsCounterparty(false);
                              setMSMESelected(false);
                            }
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.nonFinancierType || ""}
                          invalid={
                            validation.touched.nonFinancierType &&
                            validation.errors.nonFinancierType
                          }
                        >
                          <option value="" disabled>
                            Select Non financier (Entity)Type
                          </option>
                          {nonFinTypeList.map((option) => (
                            <option key={uId()} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.nonFinancierType &&
                          validation.errors.nonFinancierType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.nonFinancierType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}

                    {isCounterparty && (
                      <Col sm="12" md="6">
                        <Label className="required-sign form-label mt-4">
                          Select Associate Anchors<i className="mdi mdi-asterisk"></i>
                        </Label>
                        <div>
                          <Select
                            name="anchors"
                            onBlur={validation.handleBlur}
                            value={selectedMulti}
                            isMulti={true}
                            onChange={handleMulti}
                            onKeyDown={(e) => {
                              anchorValues(e.target.value);
                            }}
                            options={anchorList}
                            className={`select2-selection mb-2 ${validation.touched.anchors && validation.errors.anchors ? "is-invalid" : ""}`}
                            classNamePrefix="select"
                            isClearable={true}
                          />
                          {validation.touched.anchors && validation.errors.anchors ? (
                            <FormFeedback type="invalid">
                              {validation.errors.anchors}
                            </FormFeedback>
                          ) : null}
                        </div>
                      
                      </Col>
                    )}

                    {isFinSelected && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Select Financier type
                        </Label>
                        <Input
                          name="financierType"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.financierType || ""}
                          invalid={
                            validation.touched.financierType &&
                            validation.errors.financierType
                          }
                        >
                          <option value="" disabled>
                            Select Financier Type
                          </option>
                          {finTypeList.map((option) => (
                            <option key={uId()} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.financierType &&
                          validation.errors.financierType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.financierType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}

                    {isNonFinSelected && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          MSME /Non MSME 
                        </Label>
                        {msmeDropDown.map((option) => (
                          <div key={option.dropdownValue}>
                            <Input
                              type="radio"
                              name="msmeNoNmsme"
                              value={option.displayName || ""}
                              checked={msmeNmsme === option.displayName}
                              onChange={(e) => {
                                handleChangeradio(e, option);
                                if (e.target.value === "MSME") {
                                  setMSMESelected(true);
                                } else {
                                  setMSMESelected(false);
                                }
                              }}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.msmeNoNmsme &&
                                validation.errors.msmeNoNmsme
                              }
                              style={{ marginRight: '10px' }}

                            />
                            <Label check>{option.displayName}</Label>

                          </div>
                        ))}
                        {validation.touched.msmeNoNmsme &&
                          validation.errors.msmeNoNmsme ? (
                          <FormFeedback type="invalid">
                            {validation.errors.msmeNoNmsme}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}

                    {isMSMESelected && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Enter Udyam Number </Label>
                          <Input
                          name="udyamNumber"
                          type="text"
                          placeholder="Enter Udyam Number"
                          onChange={handleUdyamNumberChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.udyamNumber || ""}
                          invalid={
                            validation.touched.udyamNumber &&
                            validation.errors.udyamNumber
                          }
                        />
                        {validation.touched.udyamNumber &&
                          validation.errors.udyamNumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.udyamNumber}
                          </FormFeedback>
                        ) : null}
                        </Col>
                      )}
                    {isMSMESelected && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Select MSME Type 
                        </Label>
                        <Input
                          name="msmeType"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.msmeType || ""}
                          invalid={
                            validation.touched.msmeType &&
                            validation.errors.msmeType
                          }
                        >
                          <option value="" disabled>
                            Select MSME Type
                          </option>
                          {msmeTypeList.map((option) => (
                            <option key={uId()} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.msmeType &&
                          validation.errors.msmeType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.msmeType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}
                    <Col sm="12" md="6">
                      <Label className="required-sign form-label mt-4">
                        Select Region<i className="mdi mdi-asterisk"></i>
                      </Label>   
                      <Input
                        name="region"
                        type="select"
                        onChange={(e) => {
                          validation.handleChange(e);
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.region || ""}
                        invalid={
                          validation.touched.region &&
                          validation.errors.region
                        }
                      >
                        <option value="" disabled>
                          Select Region
                        </option>
                        {regionList.map((option) => (
                          <option key={uId()} value={option.dropdownValue}>
                            {option.displayName}
                          </option>
                        ))}
                      </Input>
                      {validation.touched.region &&
                        validation.errors.region ? (
                        <FormFeedback type="invalid">
                          {validation.errors.region}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm="12" md="6">
                      <Label className="required-sign form-label mt-4">
                        Select Relationship Manager <i className="mdi mdi-asterisk"></i>
                      </Label>
                      <Input
                        name="programOwner"
                        type="select"
                        placeholder="Select Relationaship Manager"
                        onChange={(e) => {
                          validation.handleChange(e);
                        }}
                        value={validation.values.programOwner || ""}
                        invalid={
                          validation.touched.programOwner &&
                          validation.errors.programOwner
                        }
                      >
                        <option value="" disabled>Select Relationaship Manager</option>
                        {ownerList.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.firstName} {data.lastName}
                          </option>
                        ))}

                      </Input>
                      {validation.touched.programOwner &&
                        validation.errors.programOwner ? (
                        <FormFeedback type="invalid">
                          {validation.errors.programOwner}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    {isNonFinSelected && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Enter Turnover (₹)
                        </Label>
                        <Input
                          name="turnOver"
                          type="text"
                          placeholder="Enter turnover"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.turnOver || ""}
                          invalid={
                            validation.touched.turnOver &&
                            validation.errors.turnOver
                          }
                        />
                        {validation.touched.turnOver &&
                          validation.errors.turnOver ? (
                          <FormFeedback type="invalid">
                            {validation.errors.turnOver}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}

                    {isCounterparty && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                        Total Purchases (₹)
                        </Label>
                        <Input
                          name="totalPurchase"
                          type="text"
                          placeholder="Enter total purchases"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.totalPurchase || ""}
                          invalid={
                            validation.touched.totalPurchase &&
                            validation.errors.totalPurchase
                          }
                        />
                        {validation.touched.totalPurchase &&
                          validation.errors.totalPurchase ? (
                          <FormFeedback type="invalid">
                            {validation.errors.totalPurchase}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}

                    {isNonFinSelected && (
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Nature Of Business 
                        </Label>
                        <Input
                          name="natureOfBusiness"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.natureOfBusiness || ""}
                          invalid={
                            validation.touched.natureOfBusiness &&
                            validation.errors.natureOfBusiness
                          }
                        >
                          <option value="" disabled>
                            Select Nature Of Business
                          </option>
                          <option value="Services">Services</option>
                          <option value="Retialer">Retialer</option>
                          <option value="Trader">Trader</option>
                          <option value="Manufacturing">Manufacturing</option>
                          <option value="Wholesaler">Wholesaler</option>
                          <option value="Distributor">Distributor</option>
                          <option value="Agriculture & Allied Activities">
                            Agriculture & Allied Activities
                          </option>
                          <option value="Non Profit Organization">
                            Non Profit Organization
                          </option>
                          <option value="Others">Others</option>
                        </Input>
                        {validation.touched.natureOfBusiness &&
                          validation.errors.natureOfBusiness ? (
                          <FormFeedback type="invalid">
                            {validation.errors.natureOfBusiness}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}

                    <Col sm="12" md="6">
                      <Label className="form-label mt-4">
                        Company Description
                      </Label>
                      <Input
                        name="companyDescription"
                        type="textarea"
                        placeholder="Company Description"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.companyDescription || ""}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col className="mt-4">
                      <div className="text-end">
                        <button
                          type="submit"
                          className="btn btn-success save-customer"
                        >
                          Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              ) : (
              <div>
                <Row>
                <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Entity Name</Label>
                      <span className="mb-0 entityDetailsValue">{validation.values.entityName}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">GSTIN</Label>
                      <span className="mb-0 entityDetailsValue">{validation.values.gstnIn || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">PAN</Label>
                    <span className="mb-0 entityDetailsValue">{validation.values.pan || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">CIN</Label>
                      <span className="mb-0 entityDetailsValue">{validation.values.cin || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Entity Constitution</Label>
                    <span className="mb-0 entityDetailsValue">{validation.values.entityConstitution || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Date of Incorporation</Label>
                      <span className="mb-0 entityDetailsValue">{validation.values.dateOfIncorporation ? formatDateString(validation.values.dateOfIncorporation) : "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Region</Label>
                      <span className="mb-0 entityDetailsValue">{formatFinancierName(validation.values.region) || "-"}</span>
                  </Col>
                      {isNonFinSelected && (
                        <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                          <Label className="d-block entityDetails">Turnover</Label>
                          <span className="mb-0 entityDetailsValue">{formatNumberWithCommas(validation?.values?.turnOver) || "-"}</span>
                        </Col>
                      )}
                       {isCounterparty && (
                        <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                          <Label className="d-block entityDetails">Total Purchases</Label>
                          <span className="mb-0 entityDetailsValue">{formatNumberWithCommas(validation?.values?.totalPurchase) || "-"}</span>
                        </Col>
                      )}
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Entity Type</Label>
                    <span className="mb-0 entityDetailsValue">{validation?.values?.entityType || "-"}</span>
                  </Col>
                  
                  {isNonFinSelected && (
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                  <Label className="d-block entityDetails">Non-financier Type</Label>
                  <span className="mb-0 entityDetailsValue">{validation.values.nonFinancierType || "-"}</span>
                </Col>
                  )}
                  {isFinSelected && (
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                  <Label className="d-block entityDetails">Financier Type</Label>
                  <span className="mb-0 entityDetailsValue">{formatFinancierName(validation.values.financierType) || "-"}</span>
                </Col>
                  )}
                  {msmeNmsme && (
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">MSME / Non-MSME</Label>
                      <span className="mb-0 entityDetailsValue">{validation.values.msmeNoNmsme || "-"}</span>
                    </Col>
                      )}
                    {isMSMESelected && (
                      <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">MSME Tpe</Label>
                      <span className="mb-0 entityDetailsValue">{validation.values.msmeType || "-"}</span>
                    </Col>
                    )}
                    {isMSMESelected && (
                      <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Udyam Number</Label>
                      <span className="mb-0 entityDetailsValue">{validation.values.udyamNumber || "-"}</span>
                    </Col>
                    )}
                    {isNonFinSelected && (
                      <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Nature of Business</Label>
                      <span className="mb-0 entityDetailsValue">{validation.values.natureOfBusiness || "-"}</span>
                    </Col>
                      )}
                      
                    
                  {isCounterparty && (
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Associate Anchors</Label>
                      {selectedMulti && selectedMulti.length > 0 ? (
                        <ul className="list-unstyled mb-0 entityDetailsValue">
                          {selectedMulti?.map((anchor, index) => (
                            <li key={index}>
                              {index + 1}. {anchor.label}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span className="mb-0 entityDetailsValue">No anchors associated</span>
                      )}
                    </Col>
                  )}
                </Row>     
              
                <div style={{ marginTop: '3%', borderTop: '1px solid #f0f0f0' }}>
                </div>
                  {validation.values.programOwner && (
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Relationship Manager</Label>
                      <span className="mb-0 entityDetailsValue">
                      {validation.values.RM || 'N/A'}
                    </span>
                    </Col>
                  )}
                  <div style={{ marginTop: '3%', borderTop: '1px solid #f0f0f0' }}>
                  </div>
                  <Row>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Entity Contact Name</Label>
                      <span className="mb-0 entityDetailsValue">{getDisplayNamePOC(pocList) || "-"}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Entity Contact No</Label>
                      <span className="mb-0 entityDetailsValue">{pocList.contactNumber || "-"}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Entity Contact Email</Label>
                      <span className="mb-0 entityDetailsValue">{pocList.email || "-"}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Entity Contact Designation</Label>
                      <span className="mb-0 entityDetailsValue">{pocList.designation || "-"}</span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                      <Label className="d-block entityDetails">Entity Contact Date Of Birth</Label>
                      <span className="mb-0 entityDetailsValue">{dateFormat(pocList.dateOfBirth,"DD-MM-YYYY") || "-"}</span>
                    </Col>
                  </Row>

                    {validation?.values?.companyDescription && (
                      <Row>
                        <Col sm="12" md="12" lg="12" className="mb-3 mt-3">
                          <Label className="d-block entityDetails">Company Description</Label>
                          <p className="mb-0 entityDetailsValue font-size-14 dark-grey">
                            {isReadMoreDes ? validation.values.companyDescription : validation.values.companyDescription.slice(0, 290)}
                            {validation.values.companyDescription.length > 100 && (
                              <span className="entityDetails font-size-14 "
                                onClick={() => {
                                  setIsReadMoreDes(!isReadMoreDes);
                                }}
                                style={{
                                  color: "grey",
                                  cursor: "pointer",
                                  marginLeft: "8px",
                                }}
                              >
                                {isReadMoreDes ? "Read less" : "Read more..."}
                              </span>
                            )}
                          </p>
                        </Col>
                      </Row>
                    )}

                    {description && (<div>
                      <h5 className="text-success d-block entityDetailsValue mb-2 mt-2">
                        About the corporate
                      </h5>
                      <p className="mb-0 entityDetailsValue font-size-14 dark-grey">
                        {isReadMore ? description : truncatedDescription}
                        {description.length > 100 && (
                          <span className="entityDetails font-size-14 "
                            onClick={toggleReadMore}
                            style={{
                              color: "grey",
                              cursor: "pointer",
                              marginLeft: "8px",
                            }}
                          >
                            {isReadMore ? "Read less" : "Read more..."}
                          </span>
                        )}
                      </p>
                    </div>)}

                  <div style={{ marginTop: '3%', borderTop: '1px solid #f0f0f0' }}></div>

                  <Row>
                    <div className="d-sm-flex justify-content-between align-items-center mt-3 note-footer">
                      {entity[0]?.createdByUser ? (
                        <p className="mb-0">
                          {entity[0]?.createdByUser.first_name}{" "}
                          {entity[0]?.createdByUser.last_name}
                        </p>) : ("")}

                      <p className="mb-0">
                        {dateFormat(entity[0]?.createdAt,"DD-MM-YYYY")} |{" "}
                        {entity[0]?.createdAt ? formatDistanceToNow(new Date(entity[0]?.createdAt), {
                          addSuffix: true,
                        })
                          : ""}
                      </p>
                    </div>
                  </Row>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {!isFinSelected && (
        <CreditRatings isOpen={isCreditAccordionOpen } onAccordionToggle={handleCreditAccordionToggle}/>
      )} 
      {!isFinSelected && (
        <InsuranceDetails isOpen={isInsuranceAccordionOpen } onAccordionToggle={handleAccordionToggle}/>
      )}  
      <EntityAddress isOpen={isAddressAccordionOpen} onAccordionToggle={handleAddressAccordionToggle}/>
      
      {/* {!isFinSelected && (
        <BankDetails />
      )}  */}
      <PointOfContact entityType={entity[0]?.nonFinancierType} isOpen={isPocAccordionOpen} onAccordionToggle={handlePocAccordionToggle} />
      {entity[0]?.nonFinancierType == 'Counterparty' && (
        <AnchorContact anchorList={selectedMulti} onContactAdded={fetchAnchorContacts} isOpen={isAnchorAccordionOpen} onAccordionToggle={handleAnchorToggle}/>
      )}
      <UsersTable entityType={entity[0]?.entityType} isOpen={isUserAccordionOpen} onAccordionToggle={handleUserToggle} />
      {showCommonDialog && (
        <CommonDialog
          isShow={showCommonDialog.isShow}
          header={"Alert"}
          message={showCommonDialog.message}
          data={showCommonDialog.data}
          postitiveBtn={"Save it"}
          negativeBtn={"Close"}
          onCloseFn={dialogAction}
        ></CommonDialog>
      )}
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      
    </React.Fragment>
  );
  
};


const formatNumberWithCommas = (number) => {
  if (number) {
    const formattedNumber = number.toString().replace(/\./, ",");
    const parts = formattedNumber.split(",");
    if (parts[0].length > 3) {
      const lastThree = parts[0].substr(parts[0].length - 3);
      const remaining = parts[0].slice(0, parts[0].length - 3);
      parts[0] =
        remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }

    return "₹" + " " + parts.join(".");
  }
};

export default withRouter(UpdateEntity);

UpdateEntity.propTypes = {
  history: PropTypes.object,
};
